module.exports = __webpack_public_path__ + "static/img/home_bottom_03.bb4f707.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_bottom_03.jpg
// module id = ELLD
// module chunks = 1